module.exports = __webpack_public_path__ + "img/go.1635442e.png";